import { render, staticRenderFns } from "./CV-Short-Content.vue?vue&type=template&id=4e9d5235&scoped=true&"
import script from "./CV-Short-Content.vue?vue&type=script&lang=js&"
export * from "./CV-Short-Content.vue?vue&type=script&lang=js&"
import style0 from "./CV-Short-Content.vue?vue&type=style&index=0&id=4e9d5235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d5235",
  null
  
)

export default component.exports